import React, { useContext, useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ConsultaConfiguracaoEmail from '../../../../../lib/json/consultas/ConfiguracaoEmail.json'
import ConsultaCentroCusto from '../../../../../lib/json/consultas/CentroCustoSelect.json'
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import {ConsultaAPI} from "../../../../../backend/ConsultaAPI";
import ConsultaTotvs from "../../../../../backend/ConsultaTotvs";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../../../App";
import { ConsumoAPI_DELETE } from "../../../../../backend/ConsumoAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { usePopUp } from "../../../../components/BootBox";


function ListaConfiguracaoEmail(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const columns = [
        {
            Header: 'ID',
            accessor: 'Id',
        },
        {
            Header: 'Centro Custo',
            accessor: 'DescricaoCentroCusto',
        },
        {
            Header: 'Nome',
            accessor: 'Nome',
        },
        {
            Header: 'E-mail',
            accessor: 'Email',
        }
    ];

    var [carregar, setCarregar] = useState(false);
    var consultaDefault  = ConsultaConfiguracaoEmail.consulta;
    var consultaCCDefault  = ConsultaCentroCusto.consulta + " WHERE CTT.D_E_L_E_T_ <> '*'";
    var [data, setData]   = useState([]);


    useEffect(() => {
        loadListaConfiguracaoEmail();
    }, []);
    
    // Processa consulta do grid
    const loadListaConfiguracaoEmail = async () => {
        setCarregar(true);
        var retConsulta = await ConsultaAPI( consultaDefault );
        
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.Id}`)
    }
    
    const handleExcluir = async (row) => {
        const idRow = row.values.Id;
        const Mensagem = `Tem certeza que deseja excluir o registro ${idRow + ' - ' + row.values.Nome}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(id) => {
        FechaBootBox()
        try {
            setCarregar(true);
            const rota = 'configuracaoEmail/' + id;
            const retConsumo = await ConsumoAPI_DELETE(rota);
            SucessoMsg(retConsumo.description);
            loadListaConfiguracaoEmail();
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    };
    
    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Configuração de E-mail"/>
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadListaConfiguracaoEmail}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaConfiguracaoEmail;